import React from 'react';
import { ErrorMessage, FormikProps } from 'formik';
import styled from 'styled-components';

import DatePickerField from '@shared/fields/DatePickerField';
import { LabeledField } from '../../../../LabeledField';
import { FONT_FAMILY_MAIN, BLUE_GREY } from '../../../../../theme';
import { REVIEW_MIN_DATE_ISO } from '../../../../../constants';
import Textareafield from '../../../../fields/Textareafield';
import { TextareaInfo } from '../../../TextareaInfo';
import { FORM_TEXTS } from '../../formDictionary';
import { MESSAGE_MIN_LENGTH } from '../../constants';
import { ReviewFormValues } from '../../types';
import { ErrorMessageContainer } from '../../../../fields/common/ErrorMessageContainer';

const FieldComment = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: ${BLUE_GREY};
  margin-top: 8px;
`;

type ExamCenterStepProps = FormikProps<ReviewFormValues> & {
  reviewTextRef: React.RefObject<HTMLTextAreaElement>;
};

const ExamCenterStep = ({
  values, errors, touched, setFieldValue, handleBlur, handleChange, reviewTextRef,
}: ExamCenterStepProps) => {
  const { textarea, examDate } = FORM_TEXTS;

  const handleDatepickerChange = (field, val) => {
    setFieldValue(field, val);
  };

  return (
    <>
      <LabeledField label={examDate.label}>
        <DatePickerField
          name="examDate"
          placeholderText={examDate.placeholder}
          value={values.examDate}
          maxDate={new Date()} // today
          minDate={new Date(REVIEW_MIN_DATE_ISO)}
          onChange={handleDatepickerChange}
          onBlur={handleBlur}
          dateFormat="dd MMMM yyyy"
          valid={touched.examDate && !errors.examDate}
        />
        <ErrorMessage component={ErrorMessageContainer} name="examDate" />
      </LabeledField>
      <LabeledField
        label=""
        isFullWidthLabel
        error={errors.textareaField && touched.textareaField}
      >
        <Textareafield
          name="textareaField"
          minLength={MESSAGE_MIN_LENGTH}
          value={values.textareaField}
          onChange={handleChange}
          onBlur={handleBlur}
          supplementaryInfo={(
            <TextareaInfo
              tooltipContent="Parlez de l'accueil que vous avez reçu, des conditions d'examen, du matériel, des locaux, etc"
            />
          )}
          valid={touched.textareaField && !errors.textareaField}
          textareaRef={reviewTextRef}
        />
        <ErrorMessage component={ErrorMessageContainer} name="textareaField" />
        <FieldComment>
          <a href="/a-propos/conditions-particulieres-avis" target="_blank" rel="noopener noreferrer">
            {textarea.rulesLink}
          </a>
          <div>{textarea.comment}</div>
        </FieldComment>
      </LabeledField>
    </>
  );
};

export { ExamCenterStep };
